import React, { useState } from "react";
import "./Notifications.css";
import { Container } from "react-bootstrap";
import NotificationCenter from "../../Reusables/NotificationCenter/NotificationCenter";

const Notifications: React.FC = () => {
    const [sendingNotification, setSendingNotification] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);

    return (
        <Container fluid className="admin-page-container py-4">
            <NotificationCenter
                sendingNotification={sendingNotification}
                setSendingNotification={setSendingNotification}
                error={error}
                setError={setError}
                successMessage={successMessage}
                setSuccessMessage={setSuccessMessage}
            />
        </Container>
    );
};

export default Notifications;